import { render, staticRenderFns } from "./AreaDetails.vue?vue&type=template&id=11e178d8&scoped=true"
import script from "./AreaDetails.vue?vue&type=script&lang=ts"
export * from "./AreaDetails.vue?vue&type=script&lang=ts"
import style0 from "./AreaDetails.vue?vue&type=style&index=0&id=11e178d8&prod&lang=css&scoped=true"
import style1 from "./AreaDetails.vue?vue&type=style&index=1&id=11e178d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e178d8",
  null
  
)

export default component.exports